module.exports = __webpack_public_path__ + "img/6-partagez.9e0dc71a.png";